import {
  ArrowForwardIos,
  ContentCopy,
  Delete,
  Message
} from "@mui/icons-material";
import React, { memo } from "react";
import { Box, Typography, IconButton, Stack, Tooltip } from "@mui/material";

import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <Box
      sx={{
        backgroundColor: "rgba(25, 30, 45, 0.9)",
        backdropFilter: "blur(10px)",
        padding: "16px",
        borderRadius: "16px",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        boxShadow: "0 10px 15px -3px rgba(37, 99, 235, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
        width: 260,
        position: "relative",
        transition: "all 0.3s ease",
        "&:hover": {
          borderColor: "primary.main",
          boxShadow: "0 20px 25px -5px rgba(37, 99, 235, 0.2)",
        }
      }}
      className="node-container"
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#3b82f6",
          width: "12px",
          height: "12px",
          border: "2px solid #0B0F1C",
          left: "-7px",
        }}
        isConnectable={isConnectable}
      />

      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Box
            sx={{
              display: "flex",
              padding: "6px",
              borderRadius: "8px",
              background: "rgba(37, 99, 235, 0.15)",
              color: "#3b82f6"
            }}
          >
            <Message sx={{ fontSize: 18 }} />
          </Box>
          <Typography variant="subtitle2" sx={{ color: "#fff", fontWeight: 700, letterSpacing: "0.5px" }}>
            MENSAGEM
          </Typography>
        </Stack>

        <Stack direction="row" spacing={0.5}>
          <Tooltip title="Duplicar">
            <IconButton
              size="small"
              onClick={() => {
                storageItems.setNodesStorage(id);
                storageItems.setAct("duplicate");
              }}
              sx={{ color: "rgba(255,255,255,0.4)", "&:hover": { color: "#fff" } }}
            >
              <ContentCopy sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Excluir">
            <IconButton
              size="small"
              onClick={() => {
                storageItems.setNodesStorage(id);
                storageItems.setAct("delete");
              }}
              sx={{ color: "rgba(255,255,255,0.4)", "&:hover": { color: "#f87171" } }}
            >
              <Delete sx={{ fontSize: 14 }} />
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>

      <Box
        sx={{
          backgroundColor: "rgba(255,255,255,0.03)",
          borderRadius: "10px",
          padding: "12px",
          border: "1px solid rgba(255,255,255,0.05)",
          maxHeight: "100px",
          overflow: "hidden"
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "rgba(255,255,255,0.8)",
            lineHeight: 1.5,
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            fontSize: "0.8rem"
          }}
        >
          {data.label || "Sem conteúdo..."}
        </Typography>
      </Box>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#3b82f6",
          width: "12px",
          height: "12px",
          border: "2px solid #0B0F1C",
          right: "-7px",
        }}
        isConnectable={isConnectable}
      />
    </Box>
  );
});
